import {
  LeftCircleOutlined,
  SwapOutlined,
  SwapRightOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  DatePicker,
  Row,
  notification,
  Pagination,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  checkRepayment,
  formatNumberWithDots,
  getStatusDiv,
} from "../../helpers/utils";
import locale from "antd/es/date-picker/locale/vi_VN";
import $axios from "../../services/axios";
import DetailTransaction from "../Common/DetailTransaction";
import moment from "moment";
import _ from "lodash";
import dayjs from "dayjs";

const History = ({
  airports,
  onChangeStep,
  setLoading,
  airlines,
  fareclass,
}) => {
  //NOTE: 1 chiều vmbBookings.length === 1 || route.split("|").length === 1
  //NOTE: 2 chiều là TH còn lại
  //NOTE: 2 chiều thì vmbBookings = 1 hoặc vmbBookings = 2
  const [form] = Form.useForm();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [detailTicket, setDetailTicket] = useState(null);
  const [listHistory, setListHistory] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const rangePresets = [
    {
      label: "7 ngày qua",
      value: [dayjs().add(-7, "d"), dayjs()],
    },
    {
      label: "14 ngày qua",
      value: [dayjs().add(-14, "d"), dayjs()],
    },
    {
      label: "30 ngày qua",
      value: [dayjs().add(-30, "d"), dayjs()],
    },
    {
      label: "90 ngày qua",
      value: [dayjs().add(-90, "d"), dayjs()],
    },
  ];

  useEffect(() => {
    getListHistory(currentPage, _.get(rangePresets, "[0].value", []));
  }, []);

  const getListHistory = async (page, dateRange) => {
    const startTime = dayjs(dateRange[0]).format("DD/MM/YYYY");
    const endTime = dayjs(dateRange[1]).format("DD/MM/YYYY");
    setLoading(true);
    try {
      const res = await $axios.$get(
        `/order-flight/findByAllUser?startdate=${startTime}&enddate=${endTime}&page=${currentPage}&pageSize=10`
      );
      setListHistory(res.data.data.data);
      setTotal(res.data.data.data.totalRecordCount);
    } catch (error) {
      notification.error({
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    } finally {
      setLoading(false);
    }
  };

  const OrderCountdown = ({ createdAt }) => {
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
      const deadline = dayjs(createdAt).add(1, "minute");

      const updateTimer = () => {
        const now = dayjs();
        const diff = deadline.diff(now, "second");
        setTimeLeft(diff > 0 ? diff : 0);
      };

      updateTimer(); // initial call
      const timerId = setInterval(updateTimer, 1000);

      return () => clearInterval(timerId);
    }, [createdAt]);

    if (timeLeft <= 0) {
      return null; // ẩn bộ đếm khi hết giờ
    }

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;

    return (
      <span className="text-primary text-center text-[12px]">
        {`${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`}
      </span>
    );
  };

  const onFinish = async (values) => {
    try {
      await getListHistory(currentPage, values.dateRange);
    } catch (error) {
      notification({
        status: "error",
        message: "Thất bại",
        description: "Đã có lỗi xảy ra!",
      });
    }
  };

  const verifyFlight = async (item) => {
    const vmbFareData = _.get(item, "vmbBookings[0].vmbFareData", []);
    if (!vmbFareData.length) return false;
    setLoading(true);
    try {
      const totalNetPriceOrigin = _.sum(
        _.map(vmbFareData, (fare) => fare.totalNetPrice)
      );
      const body = {
        ListFareData: _.map(vmbFareData, (f) => {
          return {
            Session: f.session,
            FareDataId: f.fareDataId,
            ListFlight: JSON.parse(f.listFlight).map((f2) => {
              return {
                flightvalue: f2.flightvalue,
              };
            }),
          };
        }),
      };
      const res = await $axios.$post("/flights/verifyflight", body);
      if (res.data.data.ErrorCode === "000") {
        const totalNetPriceCompare =
          _.get(res.data.data, "ListFareStatus[0].FareData.TotalNetPrice", 0) +
          _.get(res.data.data, "ListFareStatus[1].FareData.TotalNetPrice", 0);
        return totalNetPriceOrigin === totalNetPriceCompare;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    } finally {
      setLoading(false);
    }
  };

  const rePayment = async (item) => {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.NativeJavascriptInterface
    ) {
      // Chuyển đổi dữ liệu thành chuỗi JSON và gửi qua Swift
      window.webkit.messageHandlers.NativeJavascriptInterface.postMessage({
        orderCode: item.ordercode,
      });
    } else {
      console.error(
        "NativeJavascriptInterface không tồn tại hoặc không được hỗ trợ.",
      );
    }
    // Send orderCode for Android
    if (window.webkit !== undefined) {
      if (window.webkit.messageHandlers.appInterface !== undefined) {
        window.webkit.messageHandlers.appInterface.postMessage(
          JSON.stringify({
            orderCode: item.ordercode,
          }),
        );
      }
    }
    if (window.appInterface !== undefined) {
      window.appInterface.postMessage(
        JSON.stringify({
          orderCode: item.ordercode,
        }),
      );
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center">
      <div className="w-full 0  bg-white shadow-lg rounded-lg">
        <img
          className="w-full h-[260px] object-cover bg-primary"
          src="/images/earth.svg"
          alt=""
        />
        <div className="w-[92%] mx-auto absolute top-[7%] left-1/2 transform -translate-x-1/2 -translate-y-4/5 pb-[40px] flex flex-col">
          <div className="flex justify-center items-center">
            <div className="flex flex-col gap-2 items-center w-full">
              <div className="w-full flex items-center justify-between">
                <LeftCircleOutlined
                  onClick={() => {
                    onChangeStep(1);
                  }}
                  className="text-white text-[32px]"
                />
                <svg
                  width="48"
                  onClick={() => {
                    onChangeStep(1);
                  }}
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-primary"
                >
                  <g clipPath="url(#clip0_1_281)">
                    <path
                      d="M47.5862 24C47.5862 37.2548 37.0263 48 24 48C10.9737 48 0.413818 37.2548 0.413818 24C0.413818 10.7452 10.9737 0 24 0C37.0263 0 47.5862 10.7452 47.5862 24Z"
                      fill="white"
                    />
                    <path
                      d="M32.1425 21.1081L26.3925 26.8581L32.785 37.4481C32.834 37.5293 32.9008 37.5982 32.9805 37.6497C33.0601 37.7012 33.1504 37.7339 33.2445 37.7454C33.3386 37.7568 33.4341 37.7467 33.5237 37.7158C33.6134 37.6848 33.6948 37.6339 33.7618 37.5669L35.1837 36.145C35.5909 35.7399 35.878 35.2299 36.0132 34.6716C36.1483 34.1132 36.1262 33.5284 35.9493 32.9819L32.1425 21.1081Z"
                      fill="currentColor"
                    />
                    <path
                      d="M20.4375 31.8369C22.0381 30.8836 23.514 29.735 24.8312 28.4175L35.9812 17.2706C37.4456 15.8063 38.2662 11.7531 37.2312 10.7181C36.1862 9.67312 32.1425 10.5031 30.6781 11.9681L19.5275 23.1144C18.21 24.432 17.0612 25.9081 16.1075 27.5088L12.1462 34.9688C12.0841 35.0848 12.0609 35.2177 12.0801 35.348C12.0994 35.4782 12.16 35.5988 12.2531 35.6919C12.3462 35.7849 12.4668 35.8456 12.597 35.8648C12.7272 35.8841 12.8602 35.8609 12.9762 35.7987L20.4375 31.8369Z"
                      fill="currentColor"
                    />
                    <path
                      d="M10.5 15.16L21.0869 21.555L26.8406 15.805L14.9656 11.9969C14.4188 11.8195 13.8336 11.797 13.2748 11.9319C12.716 12.0668 12.2056 12.3539 11.8 12.7612L10.3781 14.1831C10.3112 14.2504 10.2605 14.332 10.2298 14.4218C10.1991 14.5115 10.1893 14.6071 10.201 14.7013C10.2128 14.7954 10.2458 14.8856 10.2976 14.9651C10.3494 15.0446 10.4186 15.1112 10.5 15.16Z"
                      fill="currentColor"
                    />
                    <path
                      d="M35.25 15.9819H35.2231C35.141 15.9784 35.0605 15.9588 34.986 15.9242C34.9115 15.8896 34.8446 15.8407 34.7891 15.7802C34.7335 15.7197 34.6904 15.6489 34.6623 15.5717C34.6341 15.4946 34.6214 15.4127 34.625 15.3306C34.6358 15.071 34.5927 14.812 34.4985 14.5699C34.4042 14.3278 34.2609 14.1078 34.0775 13.9238C33.8942 13.7386 33.6741 13.5941 33.4314 13.4996C33.1887 13.405 32.9289 13.3626 32.6687 13.375C32.5045 13.3772 32.3457 13.3165 32.2247 13.2055C32.1038 13.0944 32.0299 12.9413 32.0181 12.7775C32.0144 12.6953 32.027 12.6132 32.0551 12.5359C32.0832 12.4585 32.1263 12.3875 32.182 12.3269C32.2376 12.2663 32.3046 12.2172 32.3793 12.1826C32.4539 12.1479 32.5346 12.1284 32.6168 12.125C33.0498 12.1061 33.4819 12.1775 33.8858 12.3346C34.2897 12.4917 34.6565 12.7311 34.9629 13.0375C35.2693 13.344 35.5086 13.7108 35.6656 14.1147C35.8226 14.5187 35.8939 14.9508 35.875 15.3837C35.868 15.5448 35.7991 15.697 35.6827 15.8084C35.5662 15.9199 35.4112 15.982 35.25 15.9819Z"
                      fill="white"
                    />
                    <path
                      d="M10.8694 28.375C10.7426 28.3658 10.616 28.3955 10.5065 28.4601C10.397 28.5247 10.3098 28.6212 10.2565 28.7366C10.2033 28.8521 10.1865 28.981 10.2085 29.1062C10.2304 29.2315 10.29 29.347 10.3794 29.4375L13.4506 32.5125L15.4587 28.73L10.8694 28.375Z"
                      fill="currentColor"
                    />
                    <path
                      d="M18.5031 37.5656C18.5936 37.655 18.7092 37.7146 18.8344 37.7365C18.9596 37.7585 19.0886 37.7417 19.204 37.6885C19.3195 37.6352 19.4159 37.548 19.4805 37.4385C19.5452 37.329 19.5748 37.2024 19.5656 37.0756L19.2125 32.4856L15.4294 34.4944L18.5031 37.5656Z"
                      fill="currentColor"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_281">
                      <rect width="48" height="48" fill="white" />
                    </clipPath>
                  </defs>
                </svg>

                <div className="w-8 h-8"></div>
              </div>
              <h2 className="text-white text-[16px] font-semibold">
                Lịch sử đặt vé
              </h2>
              <div className="w-full px-3 py-3 rounded-[20px] bg-white mt-[20px]">
                <Form
                  form={form}
                  onFinish={onFinish}
                  layout="horizontal"
                  initialValues={{
                    dateRange: rangePresets[0].value, // Giá trị mặc định cho `dateRange`
                  }}
                  className="flex items-start gap-2 m-0"
                >
                  <Form.Item
                    name={"dateRange"}
                    rules={[
                      { required: true, message: "Vui lòng chọn thời gian!" },
                    ]}
                    className="m-0 flex-1"
                  >
                    <DatePicker.RangePicker
                      popupClassName="ant-picker-no-left"
                      classNames="history-picker"
                      presets={rangePresets}
                      format="DD/MM/YYYY"
                      className="h-10"
                      locale={locale}
                      suffixIcon={
                        <svg
                          className="text-primary"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_120_8739)">
                            <path
                              d="M10.8984 14.2188C10.8984 15.0803 11.5994 15.7812 12.4609 15.7812H14.2969C15.1584 15.7812 15.8594 15.0803 15.8594 14.2188V12.3828C15.8594 11.5213 15.1584 10.8203 14.2969 10.8203H12.4609C11.5994 10.8203 10.8984 11.5213 10.8984 12.3828V14.2188ZM12.4609 12.3828H14.2969L14.2979 14.2187C14.2979 14.2187 14.2976 14.2188 14.2969 14.2188H12.4609V12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M15.0781 8.98438C15.5096 8.98438 15.8594 8.6346 15.8594 8.20312C15.8594 7.77165 15.5096 7.42188 15.0781 7.42188C14.6467 7.42188 14.2969 7.77165 14.2969 8.20312C14.2969 8.6346 14.6467 8.98438 15.0781 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M11.6797 8.98438C12.1112 8.98438 12.4609 8.6346 12.4609 8.20312C12.4609 7.77165 12.1112 7.42188 11.6797 7.42188C11.2482 7.42188 10.8984 7.77165 10.8984 8.20312C10.8984 8.6346 11.2482 8.98438 11.6797 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M19.2188 13.75C19.6502 13.75 20 13.4002 20 12.9688V4.6875C20 2.96438 18.5981 1.5625 16.875 1.5625H15.8594V0.78125C15.8594 0.349766 15.5096 0 15.0781 0C14.6466 0 14.2969 0.349766 14.2969 0.78125V1.5625H10.7422V0.78125C10.7422 0.349766 10.3924 0 9.96094 0C9.52945 0 9.17969 0.349766 9.17969 0.78125V1.5625H5.66406V0.78125C5.66406 0.349766 5.3143 0 4.88281 0C4.45133 0 4.10156 0.349766 4.10156 0.78125V1.5625H3.125C1.40188 1.5625 0 2.96438 0 4.6875V16.875C0 18.5981 1.40188 20 3.125 20H16.875C18.5981 20 20 18.5981 20 16.875C20 16.4435 19.6502 16.0938 19.2188 16.0938C18.7873 16.0938 18.4375 16.4435 18.4375 16.875C18.4375 17.7366 17.7366 18.4375 16.875 18.4375H3.125C2.26344 18.4375 1.5625 17.7366 1.5625 16.875V4.6875C1.5625 3.82594 2.26344 3.125 3.125 3.125H4.10156V3.90625C4.10156 4.33773 4.45133 4.6875 4.88281 4.6875C5.3143 4.6875 5.66406 4.33773 5.66406 3.90625V3.125H9.17969V3.90625C9.17969 4.33773 9.52945 4.6875 9.96094 4.6875C10.3924 4.6875 10.7422 4.33773 10.7422 3.90625V3.125H14.2969V3.90625C14.2969 4.33773 14.6466 4.6875 15.0781 4.6875C15.5096 4.6875 15.8594 4.33773 15.8594 3.90625V3.125H16.875C17.7366 3.125 18.4375 3.82594 18.4375 4.6875V12.9688C18.4375 13.4002 18.7873 13.75 19.2188 13.75Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 15.7812C5.31428 15.7812 5.66406 15.4315 5.66406 15C5.66406 14.5685 5.31428 14.2188 4.88281 14.2188C4.45134 14.2188 4.10156 14.5685 4.10156 15C4.10156 15.4315 4.45134 15.7812 4.88281 15.7812Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 8.98438C5.31428 8.98438 5.66406 8.6346 5.66406 8.20312C5.66406 7.77165 5.31428 7.42188 4.88281 7.42188C4.45134 7.42188 4.10156 7.77165 4.10156 8.20312C4.10156 8.6346 4.45134 8.98438 4.88281 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M4.88281 12.3828C5.31428 12.3828 5.66406 12.033 5.66406 11.6016C5.66406 11.1701 5.31428 10.8203 4.88281 10.8203C4.45134 10.8203 4.10156 11.1701 4.10156 11.6016C4.10156 12.033 4.45134 12.3828 4.88281 12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 12.3828C8.71272 12.3828 9.0625 12.033 9.0625 11.6016C9.0625 11.1701 8.71272 10.8203 8.28125 10.8203C7.84978 10.8203 7.5 11.1701 7.5 11.6016C7.5 12.033 7.84978 12.3828 8.28125 12.3828Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 8.98438C8.71272 8.98438 9.0625 8.6346 9.0625 8.20312C9.0625 7.77165 8.71272 7.42188 8.28125 7.42188C7.84978 7.42188 7.5 7.77165 7.5 8.20312C7.5 8.6346 7.84978 8.98438 8.28125 8.98438Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.28125 15.7812C8.71272 15.7812 9.0625 15.4315 9.0625 15C9.0625 14.5685 8.71272 14.2188 8.28125 14.2188C7.84978 14.2188 7.5 14.5685 7.5 15C7.5 15.4315 7.84978 15.7812 8.28125 15.7812Z"
                              fill="currentColor"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_120_8739">
                              <rect width="20" height="20" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      }
                    />
                  </Form.Item>

                  <Form.Item className="m-0">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="bg-primary h-10 font-bold text-white"
                    >
                      Tìm kiếm
                    </Button>
                  </Form.Item>
                </Form>
                {/* Hotline */}
              </div>

              <div className="w-full mt-4">
                <div className="text-center mt-8">
                  <span className="text-[#808080] font-normal">
                    Hotline hỗ trợ khách hàng{" "}
                  </span>
                  <a
                    href="tel:1900255585"
                    className="font-bold text-primary text-[16px]"
                  >
                    1900255585
                  </a>
                </div>
                <Button className="mt-3  rounded-[20px]" type="primary" ghost>
                  <p className="font-bold">Vé máy bay</p>
                </Button>
              </div>
              {listHistory.length === 0 && (
                <h2 className="w-full text-primary font-semibold text-[19px] text-center absolute top-[480px] left-1/2 transform -translate-x-1/2 p-4">
                  Không tìm thấy lịch sử đặt vé, vui lòng tìm kiếm lại
                </h2>
              )}
              {listHistory.map((item, index) => (
                <div
                  key={index}
                  className="mt-2 w-full p-4 bg-white rounded-[20px] mb-4 "
                  style={{
                    boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
                  }}
                >
                  {item?.orderplanebookings.length > 0 && (
                    <Row gutter={8} className="justify-between items-center">
                      <Col className="flex flex-col gap-2" span={24}>
                        <div className="flex gap-2 items-center">
                          <img
                            src={
                              `${process.env.REACT_APP_BASE_URL}/${
                                airlines?.find(
                                  (air) =>
                                    air.code ===
                                    item?.orderplanebookings?.[0]?.airline
                                )?.iconurl
                              }` || ""
                            }
                            alt="logo"
                            style={{ width: "auto", height: 30 }}
                          />
                          <div className="text-[12px] text-primary">
                            {
                              (airports || []).find(
                                (air) =>
                                  air.code ===
                                    item?.orderplanebookings?.[0]
                                      ?.fromairport || ""
                              )?.name
                            }{" "}
                            ({item?.orderplanebookings?.[0]?.fromairport})
                          </div>

                          {item.orderplanebookings.length === 1 ? (
                            <SwapRightOutlined className="text-primary" />
                          ) : (
                            <SwapOutlined className="text-primary" />
                          )}
                          <div className="text-[12px] text-primary">
                            {
                              (airports || []).find(
                                (air) =>
                                  air.code ===
                                    item?.orderplanebookings?.[0]?.toairport ||
                                  ""
                              )?.name
                            }{" "}
                            ({item?.orderplanebookings?.[0]?.toairport})
                          </div>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {/* <hr className="my-2" /> */}
                  <Row className="justify-between items-center">
                    <div className="flex gap-2 items-center flex-col">
                      <div>
                          <p className="text-[#808089] text-[10px]">
                            Loại vé:{" "}
                            <span>
                              {item?.orderplanes?.[0]?.recovery === 1
                                ? "Khứ hồi"
                                : "Một chiều"}
                            </span>
                          </p>
                        <p className="text-[10px] text-[#808089] mt-1">
                          Mã đơn hàng: {item?.ordercode || ""}
                        </p>
                        <p className="text-[10px] text-[#808089] mt-1">
                          Thời gian:{" "}
                          {moment(item?.createdat).format("HH:mm DD/MM/YYYY")}
                        </p>
                      </div>
                    </div>

                    <div className="flex flex-col gap-1 items-center mt-2">
                      {item?.orderplanetickets.length > 0 && (
                        <div className="flex gap-2 items-center justify-center text-center">
                          <span
                            className="text-primary text-[12px]"
                            onClick={() => {
                              setDetailTicket(item);
                              setDrawerVisible(true);
                            }}
                          >
                            Chi tiết
                            <svg
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="text-primary"
                            >
                              <path
                                d="M1 1L4.176 4L7.352 1"
                                stroke="currentColor"
                              />
                              <path
                                d="M1 4L4.176 7L7.352 4"
                                stroke="currentColor"
                              />
                            </svg>
                          </span>
                        </div>
                      )}

                      {getStatusDiv(
                        item?.paymentstatus === "Success"
                          ? item?.orderplanebookings?.[0]?.status ||
                              item?.paymentstatus
                          : item?.paymentstatus,
                        !checkRepayment(item?.orderplanebookings?.[0]?.createdat)
                      )}
                      {item?.orderplanebookings.length > 0 && 
                        checkRepayment(item?.orderplanebookings?.[0]?.createdat) &&
                        item?.paymentstatus === "PayLater" && (
                          <div className="flex flex-col items-center">
                            <div
                              onClick={() => rePayment(item)}
                              className={`text-white bg-red-500 rounded-[20px] px-2 py-1 w-fit text-[10px]`}
                            >
                              Thanh toán lại
                            </div>
                            {/* <OrderCountdown createdAt={item.createdat} /> */}
                          </div>
                        )}

                      {/* {item.paymentTransaction !== "" && (
                        <div
                          onClick={() => rePayment(item)}
                          className={`text-white bg-red-500 rounded-[20px] px-2 py-1 w-fit text-[12px]`}
                        >
                          Thanh toán lại
                        </div>
                      )} */}
                    </div>

                    <div className="font-bold text-primary text-[12px] mt-2">
                      Tồng tiền {formatNumberWithDots(item?.amount)} VND
                    </div>
                  </Row>
                </div>
              ))}

              {total > 0 && (
                <Pagination
                  current={currentPage}
                  className="mt-2"
                  total={total}
                  onChange={(page) => {
                    setCurrentPage(page);
                    getListHistory(page);
                  }}
                  pageSize={10}
                  showSizeChanger={false}
                  showQuickJumper={false}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {drawerVisible && detailTicket && (
        <DetailTransaction
          visible={drawerVisible}
          onClose={() => setDrawerVisible(false)}
          ticketDetails={detailTicket}
          airports={airports}
          fareclass={fareclass}
          airlines={airlines}
        />
      )}
    </div>
  );
};

export default History;
